import Cookies from "js-cookie";
import React from "react";
import getAxios from "../../hooks/useAxios";
import {
  Box,
  Flex,
  Text,
  useTheme,
  Image,
  Icon,
  useDisclosure,
  Button,
  Skeleton,
} from "@chakra-ui/react";
import { Theme } from "../../theme";
import { MdDeleteForever, MdOutlineModeEdit } from "react-icons/md";
import StatusConfirmationModal from "../../components/StatusConfirmModal";
import { decrypted } from "../../utils/crypto";
import { useNavigate } from "react-router-dom";
import Nodata from "../../components/Nodata";

const Index = () => {
  const axios = getAxios();
  const theme = useTheme<Theme>();
  const navigate = useNavigate();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const profile = decrypted(Cookies.get("x-z-user"));

  const access_token = Cookies.get("x-admin-auth");
  const [admin, setAdmin] = React.useState<any>([]);
  const [adminIdToDelete, setAdminIdToDelete] = React.useState<any>();
  const [isDataFetching, setIsDataFetching] = React.useState(true);

  const getAllAdmin = async () => {
    setIsDataFetching(true);
    try {
      const res = await axios.get(`/admins`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("all admin", res.data);
      setAdmin(res.data?.data);
    } catch (error) {
      console.log("error listing ad", error);
    } finally {
      setIsDataFetching(false);
    }
  };

  const deleteAdmin = async () => {
    try {
      const res = await axios.delete(`/admins/${adminIdToDelete}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("delete admin", res.data);
      getAllAdmin();
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    getAllAdmin();
  }, []);

  const handleEditButtonClick = (val: string) => {
    navigate({
      pathname: "/admin/edit",
      search: `?id=${val}`,
    });
  };

  // if (admin.length === 1)
  //   return (
  //     <Box
  //       style={{
  //         padding: "2rem",
  //       }}
  //     >
  //       <Nodata heading="No Admins Listed" />
  //     </Box>
  //   );

  return (
    <Box
      style={{
        width: "60%",
        padding: "2rem",
      }}
    >
      <Text
        sx={{
          fontSize: theme.fontSizes.subHeading1,
          marginBottom: theme.space["3xl"],
        }}
      >
        All Listed Admins
      </Text>
      <Skeleton isLoaded={isDataFetching ? false : true} minHeight={"20rem"}>
        {admin && admin.length !== 1 ? (
          <table>
            <thead>
              <tr>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Name
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Mobile
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Update
                  </Text>
                </th>
                <th>
                  <Text
                    sx={{
                      fontSize: theme.fontSizes.subHeading1,
                    }}
                  >
                    Delete
                  </Text>
                </th>
              </tr>
            </thead>
            <tbody>
              {admin
                .filter((item: any) => item.id !== profile?.id)
                .map((item: any, index: number) => (
                  <tr>
                    <td>
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.subHeading2,
                        }}
                      >
                        {item.name}
                      </Text>
                    </td>
                    <td>
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.subHeading2,
                        }}
                      >
                        {item.mobile}
                      </Text>
                    </td>
                    <td>
                      <Flex
                        sx={{
                          justifyContent: "center",
                          // background: isActive ? theme.colors.bg.main : 'transparent',
                          alignItems: "center",
                          height: "2.8rem",
                          width: "2.8rem",
                          borderRadius: "0.25rem",
                          // _hover: isActive ? { backgroundColor: theme.colors.bg.main } : { backgroundColor: theme.colors.bg.paper },
                        }}
                      >
                        <Icon
                          as={MdOutlineModeEdit}
                          width={6}
                          height={6}
                          color={theme.colors.primary.main}
                          cursor="pointer"
                          onClick={() => handleEditButtonClick(item.id)}
                        />
                      </Flex>
                    </td>
                    <td>
                      <Flex
                        sx={{
                          justifyContent: "center",
                          // background: isActive ? theme.colors.bg.main : 'transparent',
                          alignItems: "center",
                          height: "2.8rem",
                          width: "2.8rem",
                          borderRadius: "0.25rem",
                          // _hover: isActive ? { backgroundColor: theme.colors.bg.main } : { backgroundColor: theme.colors.bg.paper },
                        }}
                        onClick={() => {
                          onOpen();
                          setAdminIdToDelete(item.id);
                        }}
                      >
                        <Icon
                          as={MdDeleteForever}
                          width={6}
                          height={6}
                          color={theme.colors.primary.main}
                          cursor="pointer"
                        />
                      </Flex>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <Box
            style={{
              padding: "2rem",
            }}
          >
            <Nodata heading="No Admins Listed" />
          </Box>
        )}
      </Skeleton>
      <StatusConfirmationModal
        heading="Are you sure want to delete admin ?"
        isOpen={isOpen}
        onClose={onClose}
        handleApiCall={() => deleteAdmin()}
      ></StatusConfirmationModal>
    </Box>
  );
};

export default Index;
